<template>
    <div>
        <main id="main">
            <!-- ======= Featured Services Section Section ======= -->
            <section id="featured-services">
                <div class="container">
                    <div class="row">
                        <div class="box" style="height: 5em">
                        </div>
                    </div>
                </div>
            </section><!-- End Featured Services Section -->

            <!-- ======= About Us Section ======= -->
            <section id="capture">
                <mdb-jumbotron class="mb-0 text-center"
                               data-aos="fade-up" data-aos-delay="100"
                    v-for="(capture,index) in capture.captures"
                    :key="index">
                    <mdb-view class="my-4" :src="capture.image" alt="">
                        <a><mdb-mask waves overlay="white-slight"/></a>
                    </mdb-view>
                </mdb-jumbotron>
            </section><!-- End About Us Section -->
        </main><!-- End #main -->

    </div>
</template>

<script>
    import { mdbJumbotron, mdbCardTitle, mdbView, mdbMask, mdbIcon } from 'mdbvue';
    import {mapActions,mapState} from 'vuex'

    export default {
        name: "index",
        components: {
            mdbJumbotron,
            mdbCardTitle,
            mdbView,
            mdbMask,
            mdbIcon
        },
        created() {
            this.captureAllAction()
        },
        computed:{
          ...mapState({
              capture: (state) => state.capture.capture
          })
        },
        methods:{
            ...mapActions('capture', ['captureAllAction'])
        }
    }
</script>

<style lang="scss" scoped>
    #capture {
        background: url("../../../../public/img/about-bg.jpg") center top no-repeat fixed;
        background-size: cover;
        padding: 60px 0 40px 0;
        position: relative;

        .mb-0 {
            z-index: 10;
            width: 90%;
            margin: 3em auto;
        }
    }

    #capture::before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.7);
    }

</style>